<template>
    <div>
        <div class="blank-list">
            <blank-item v-for='(item,index) in dataList' :content='item' :itemIndex='index' :key='item.id' @blank-input='blankInput' :answerStatus='subFlag'></blank-item>
        </div>
        <sub-btn @sub-answer="subAnswer" v-if='!subFlag'></sub-btn>
        <question-analyze v-if='subFlag' :inside='analysis'></question-analyze>
    </div>
</template>
<script>
import BlankItem from 'components/PC/BlankItem'
import SubBtn from 'components/PC/SubBtn'
import psCommonMethods from './mixins/index.js'
import QuestionAnalyze from 'components/PC/QuestionAnalyze' // 答案反馈
export default {
  name: 'FillBlank',
  mixins: [psCommonMethods],
  data () {
    return {
      dataList: null,
      blankCount: 0,
      ansArr: [],
      subFlag: false,
      analysis: null
    }
  },
  created () {
    this.initData()
  },
  watch: {
    '$route' () {
      this.initData()
    }
  },
  components: {
    BlankItem,
    SubBtn,
    QuestionAnalyze
  },
  methods: {
    initData () {
      const cIndex = this.$store.state.currentChapterIndex
      const pIndex = this.$store.state.currentPartIndex
      let data = this.data.part_list[pIndex].chapter_list[cIndex]
      this.conversitionTitle(data.chapter_content.dry[0])
      this.analysis = data.chapter_content.feedback.right
      this.subFlag = data.answerShow ? data.answerShow : false// 答案反馈显示
      this.ansArr = [] // 重置保存的答案
    },
    conversitionTitle (data) {
      let count = 0
      let str = data.content.replace(/{{n}}/g, function () {
        count++
      })
      this.blankCount = count
      this.makeDataList(data)
    },
    makeDataList (allData) {
      let data = []
      for (let i = 0; i < this.blankCount; i++) {
        let obj = {}
        obj.index = this.index2ABC(i)
        obj.id = parseInt(Math.random() * 1000000)
        if (allData.answer) {
          obj.answer = allData.answer[i]
        }
        data[i] = obj
      }
      this.dataList = data
      console.log(data)
    },
    index2ABC (i) {
      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      return letters.split('')[i]
    },
    blankInput (value) {
      if (value.content !== '') {
        this.ansArr[value.index] = value.content
      } else {
        this.ansArr[value.index] = null
      }
    },
    checkAnswer () {
      let count = 0
      if (this.ansArr.length === this.blankCount) {
        this.ansArr.forEach(item => {
          if (item !== null) {
            count++
          }
        })
        if (count !== this.blankCount) {
          this.subFlag = false
        } else {
          this.subFlag = true
        }
      } else {
        this.subflag = false
      }
    },
    subAnswer () {
      this.checkAnswer()
      if (this.subFlag) {
        // 提交答案
        const ansArr = []
        const obj = {}
        obj.answer = this.ansArr
        ansArr[0] = obj
        this.setChaperAnswer(ansArr)
        // this.setLessonLocation(this.$store.state.currentPartIndex,this.$store.state.currentChapterIndex);
      } else {
        this.subAnswerAllow(true) // 显示全局提示
      }
    }
  }
}
</script>
<style lang="less" scoped>
.blank-list {
  padding: 32px 3%;
}
</style>
